// Select all heading elements within elements with the class 'common-page__plain-text' and look for hyphen placeholders
document.querySelectorAll('.common-page__plain-text h1, .common-page__plain-text h2, .common-page__plain-text h3, .common-page__plain-text h4, .common-page__plain-text h5, .common-page__plain-text h6')
    .forEach(el => replaceHyphenPlaceholdersInTextNodes(el));

function replaceHyphenPlaceholdersInTextNodes(node: Node) {
    if (node.nodeType === Node.TEXT_NODE) {
        // Replace all occurrences of '[-]' with '\u00AD' (soft hyphen)
        node.textContent = node.textContent?.replaceAll('[-]', '\u00AD') || '';
    } else if (node.nodeType === Node.ELEMENT_NODE) {
        node.childNodes.forEach(child => replaceHyphenPlaceholdersInTextNodes(child));
    }
}